angular.module("ainapp")
    .controller("employeeController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Employees";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {
                $scope.filter = {
                    Keyword: "",
                    Type: ""
                }
            }
            $scope.Init();


            $scope.Statuses = [];
            MainService.getStatusbyType("Employee").then(function (response) {
                $scope.Statuses = response.data;
            })


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.Keyword = $scope.filter.Keyword;
                        o.data.Type = $scope.filter.Type;
                        MainService.EmployeesInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Name: {
                                type: "string",
                                editable: false,
                            },
                             EmployeeId: {
                                type: "string",
                                editable: false,
                            },
                            MobileNo: {
                                type: "string",
                                editable: false,
                            },
                            Email: {
                                type: "string",
                                editable: false,
                            },
                            TelephoneNo: {
                                type: "string",
                                editable: false,
                            },
                            "Designation.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Department.Name ": {
                                type: "string",
                                editable: false,
                            },
                            "Country.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Grade.Name": {
                                type: "string",
                                editable: false,
                            },
                            "IDNo": {
                                type: "string",
                                editable: false,
                            },
                            "VisaNo": {
                                type: "string",
                                editable: false,
                            },
                            "IDExpiryDate": {
                                type: "date",
                                editable: false,
                            },
                            "VisaExpireDate": {
                                type: "date",
                                editable: false,
                            },
                            "PassportIExpireDate": {
                                type: "date",
                                editable: false,
                            },
                            "Status.Name": {
                                type: "text",
                                editable: false,
                            },
                            "Shift.Name": {
                                type: "text",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                       {
                        field: "EmployeeId",
                        title: "Emp Id",
                                    },
                                       {
                        field: "Name",
                        title: "Name",
                        headerTemplate: "{{LanguageData.Name}}",
                                    },
                    {
                        field: "Image",
                        title: "Image",
                        template: '<img  src="{{basePath}}{{dataItem.Image}}" style="width:50px;height:50px;" />',
                        headerTemplate: "{{LanguageData.Image}}",
                        width: "100px"
                                    },
                 
                    // {
                    //     field: "Email",
                    //     title: "Email",
                    //     headerTemplate: "{{LanguageData.Email}}",
                    //                 },
                   
                    {
                        field: "Designation.Name",
                        title: "Designation",
                        headerTemplate: "{{LanguageData.Designation}}",
                                    },
                    // {
                    //     field: "Department.Name",
                    //     title: "Department",
                    //     headerTemplate: "{{LanguageData.Department}}",
                    //                 },

                    {
                        field: "Country.Name",
                        title: "Nationality",
                                    },
                                     {
                        field: "JobLocation",
                        title: "Location",
                                    },
                                    {
                        field: "Shift.Name",
                        title: "Shift",
                                    },
                                       {
                        field: "VisaNo",
                        title: "Visa No",
                                    },
                                     {
                        field: "MobileNo",
                        title: "Mobile No",
                        headerTemplate: "{{LanguageData.mobileno}}",
                                    },
                                       {
                        field: "BirthDate",
                        title: "Birth Date",
                        template: "#= kendo.toString(kendo.parseDate(BirthDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        },
                         {
                        field: "DateOfJoining",
                        title: "Joining Date",
                        template: "#= kendo.toString(kendo.parseDate(DateOfJoining, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        },
                    // {
                    //     field: "Grade.Name",
                    //     title: "Grade",
                    //     headerTemplate: "{{LanguageData.Grade}}",
                    //                 },
                    // {
                    //     field: "IDNo",
                    //     title: "ID No",
                    //                 },
   
                    // {
                    //     field: "VisaExpireDate",
                    //     title: "Visa Expiry",
                    //     template: "#= kendo.toString(kendo.parseDate(VisaExpireDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                    //     },
                    // {
                    //     field: "PassportNo",
                    //     title: "Passport No",
                    //  },
                    {
                        field: "PassportIExpireDate",
                        title: "Passport Expiry",
                        template: "#= kendo.toString(kendo.parseDate(PassportIExpireDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        },
                        {
                        field: "LabourCardExpiryDate",
                        title: "Labour Card Expiry",
                        template: "#= kendo.toString(kendo.parseDate(LabourCardExpiryDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        },
                                         {
                        field: "IDExpiryDate",
                        title: "Id Expiry",
                        template: "#= kendo.toString(kendo.parseDate(IDExpiryDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        },
                    {
                        field: "Status.Name",
                        title: "Status",
                        template: "<select class='form-select'  ng-Options='c.Id as c.Name for c in Statuses' ng-model='dataItem.StatusId' ng-change='UpdateEmployeeStatus(dataItem)'></select>"
                        },

                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteVoucher(dataItem)'></button>  ",
                        width: '80px'
                        },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

            $scope.Edit = function (data) {
                $state.go("editEmployee", {
                    EmployeeId: data.Id
                });
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteVoucher = function (dataDel) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = dataDel;
                    $('#deleteModal').modal('show');
                }
            }


            $scope.DeleteWithConfirm = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });


                MainService.DeleteEmployee($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $scope.Load = false;
                        $scope.SelectedDataForDelete = {};
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $('#deleteModal').modal('hide');
                        $scope.Init();
                    } else {
                        toastr.error($scope.NetworkErrorLan);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error($scope.NetworkErrorLan);
                })
            }


            $scope.UpdateEmployeeStatus = function (data) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });


                MainService.UpdateEmployeeStatus(data.Id, data.StatusId).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $scope.Load = false;
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.Init();
                    } else {
                        toastr.error($scope.NetworkErrorLan);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error($scope.NetworkErrorLan);
                })
            }


        }])
